import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import Thankyou from 'src/assets/Buy_Policy_Images/Thankyou.svg'
import Thankyou_Background from 'src/assets/Buy_Policy_Images/Thankyou_Background.svg'
import Thankyou_Heading from 'src/assets/Buy_Policy_Images/Thankyou_Heading.svg'

const ThankYouPage = ({ handleClose }) => {
  const classes = useStyles()

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <div className={classes.mainContent}>
          <div className={classes.closeButton}>
            <IconButton onClick={() => handleClose()} id='IconButton'>
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.headingContainer}>
            <img src={Thankyou_Heading} alt='heading' />
          </div>
          <div className={classes.thankyouContainer}>
            <div className={classes.thankyouImage}>
              <img src={Thankyou} alt='thankyou' />
            </div>
            <div>
              <span className={classes.imageText}>
                We&apos;ll be in touch shortly, within an hour.
              </span>
            </div>
            <div>
              <span className={classes.note}>
                Get ready to hit the road in your new car soon!
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ThankYouPage

const useStyles = makeStyles({
  mainContainer: {
    backgroundImage: `url(${Thankyou_Background})`,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background:
      'linear-gradient(192.92deg, #4DC3E3 -240.34%, rgba(255, 255, 255, 0) 75.64%)',
  },
  mainContent: {
    width: '100%',
  },
  closeButton: {
    top: '0',
    right: '0',
    textAlign: 'right',
    padding: '10px',
  },
  headingContainer: {
    padding: '20px 30px 30px 30px',
    textAlign: 'center',
  },
  heading: {
    fontFamily: 'Poppins',
    fontSize: '36px',
    fontWeight: '400',
    color: '#000000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  subHeading: {
    fontFamily: 'poppins',
    fontSize: '13px',
    fontWeight: '400',
    color: '#000000',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    border: '1px solid',
  },
  thankyouContainer: {
    padding: '30px',
  },
  thankyouImage: {
    textAlign: 'center',
  },
  imageText: {
    fontFamily: 'poppins',
    fontSize: '15px',
    fontWeight: '400',
    color: '#000000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    lineHeight: '22.5px',
  },
  note: {
    fontFamily: 'poppins',
    fontSize: '22px',
    fontWeight: '600',
    color: '#000000',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: '28px',
  },
})
